<template>
  <modal :show="show" @close="handleKeep">
    <div id="keep-change-modal" slot="header" class="modal-header">
      <h5 class="modal-title">{{ title }}</h5>
      <button type="button" class="close" @click="handleKeep" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>

    <div slot="body">{{ body }}</div>

    <template v-slot:footer>
      <button id="btn-keep-change-cancel" class="btn btn-light btn-sm" @click="handleKeep">
        Cancel
      </button>
      <button id="btn-keep-change-confirm" class="btn btn-primary btn-sm" @click="handleChange">
        Change Association
      </button>
    </template>
  </modal>
</template>

<script>
import Modal from "../Modal";

export default {
  name: "ChangePatientAssociateModal",
  props: ["show", "body", "title"],
  methods: {
    handleChange() {
      this.$emit("change");
      this.$emit("close");
    },
    handleKeep() {
      this.$emit("close");
    }
  },
  components: {
    modal: Modal
  }
};
</script>

<style scoped></style>
